import { useCallback, useEffect, useState } from 'react';
import { getAssetCommentPending, listEpisodes } from '../api';

// 顶栏「资产设定 / 视频创作」红点：是否存在未处理评论。
// 资产评论变更会派发 'asset-comments-updated'（见 useProjectAssetComments），
// 分镜评论变更会派发 'shot-comments-updated'（见 EpisodeDetail），收到即重拉对应聚合。
export function useProjectCommentDots(projectId: string | undefined) {
  const [assetHasPending, setAssetHasPending] = useState(false);
  const [storyboardHasPending, setStoryboardHasPending] = useState(false);

  const reloadAssets = useCallback(async () => {
    if (!projectId) return;
    try {
      const rows = await getAssetCommentPending(projectId);
      setAssetHasPending((rows || []).some(r => r.count > 0));
    } catch {
      // Non-critical: nav badge. Keep current state on failure.
    }
  }, [projectId]);

  const reloadStoryboard = useCallback(async () => {
    if (!projectId) return;
    try {
      const eps = await listEpisodes(projectId);
      setStoryboardHasPending((eps || []).some(e => (e.pendingCommentCount ?? 0) > 0));
    } catch {
      // Non-critical: nav badge. Keep current state on failure.
    }
  }, [projectId]);

  useEffect(() => {
    reloadAssets();
    reloadStoryboard();
  }, [reloadAssets, reloadStoryboard]);

  useEffect(() => {
    window.addEventListener('asset-comments-updated', reloadAssets);
    window.addEventListener('shot-comments-updated', reloadStoryboard);
    return () => {
      window.removeEventListener('asset-comments-updated', reloadAssets);
      window.removeEventListener('shot-comments-updated', reloadStoryboard);
    };
  }, [reloadAssets, reloadStoryboard]);

  return { assetHasPending, storyboardHasPending };
}
